// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_main__FkKqm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.styles_card__bKTEx {
  position: absolute;
  margin-top: 272px !important;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 480px;
  height: 500px;
  border-radius: 12px;
}

.styles_documentoTextField__wft8E {
  color: #18316e !important;
  font-family: "Inter";
}



.styles_usuarioTextField__hZnDg {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_containerEmailTextField__VP0oV {
  margin-top: 12px !important;
}

.styles_emailTextField__UwQAU {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_containerSenhaTextField__NRb4D {
  margin-top: 12px !important;
  display: flex;
  flex-direction: column;
}

.styles_senhaTextField__iYvl7 {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_containerConfirmarSenhaTextField__JaSdl {
  margin-top: 12px !important;
}

.styles_confirmarSenhaTextField__G6bZh {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_botaoConfirmar__KWArx {
  background-color: #18316e !important;
  margin-top: 32px !important;
  width: 32% !important;
  font-family: "Inter" !important;
  transition: all 0.3s ease !important;
  text-transform: none !important;
  font-weight: 300 !important;
}

.styles_container__9M3SJ {
  display: flex !important;
  justify-content: left !important;
  align-items: center !important;
  margin-bottom: 44px !important;
}

.styles_titulo__3JW3r {
  font-family: "Inter" !important;
  font-size: 16px !important;
  color: #18316e !important;
}


.styles_botaoEnviar__VhxM2 {
  background-color: #18316e !important;
  margin-top: 32px !important;
  font-family: "Inter" !important;
  transition: all 0.3s ease !important;
  text-transform: none !important;
  font-weight: 300 !important;
}

.styles_botaoEnviar_disable__l\\+0Hs {
  background-color: #a3a3a3 !important;
  color: #ffffff !important;
  font-family: "Inter" !important;
  font-weight: 300 !important;
  text-transform: none !important;
  margin-top: 32px !important;
}

.styles_botaoLimpar__rSca5 {
  background-color: #ffffff !important;
  color: #464a53 !important;
  margin-top: 32px !important;
  font-family: "Inter" !important;
  transition: all 0.3s ease !important;
  text-transform: none !important;
  font-weight: 300 !important;
}

.styles_labelField__1i4HA {
  font-family: "Inter" !important;
  font-size: 12px;
}

.styles_tipoDocumentoCombo__hyCkw {
  font-size: 12px !important;
  font-family: "Inter" !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/CadastroCliente/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;;;AAIA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,qBAAqB;EACrB,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;;;AAGA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC","sourcesContent":[".main {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.card {\n  position: absolute;\n  margin-top: 272px !important;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 480px;\n  height: 500px;\n  border-radius: 12px;\n}\n\n.documentoTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n\n\n.usuarioTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.containerEmailTextField {\n  margin-top: 12px !important;\n}\n\n.emailTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.containerSenhaTextField {\n  margin-top: 12px !important;\n  display: flex;\n  flex-direction: column;\n}\n\n.senhaTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.containerConfirmarSenhaTextField {\n  margin-top: 12px !important;\n}\n\n.confirmarSenhaTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.botaoConfirmar {\n  background-color: #18316e !important;\n  margin-top: 32px !important;\n  width: 32% !important;\n  font-family: \"Inter\" !important;\n  transition: all 0.3s ease !important;\n  text-transform: none !important;\n  font-weight: 300 !important;\n}\n\n.container {\n  display: flex !important;\n  justify-content: left !important;\n  align-items: center !important;\n  margin-bottom: 44px !important;\n}\n\n.titulo {\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  color: #18316e !important;\n}\n\n\n.botaoEnviar {\n  background-color: #18316e !important;\n  margin-top: 32px !important;\n  font-family: \"Inter\" !important;\n  transition: all 0.3s ease !important;\n  text-transform: none !important;\n  font-weight: 300 !important;\n}\n\n.botaoEnviar_disable {\n  background-color: #a3a3a3 !important;\n  color: #ffffff !important;\n  font-family: \"Inter\" !important;\n  font-weight: 300 !important;\n  text-transform: none !important;\n  margin-top: 32px !important;\n}\n\n.botaoLimpar {\n  background-color: #ffffff !important;\n  color: #464a53 !important;\n  margin-top: 32px !important;\n  font-family: \"Inter\" !important;\n  transition: all 0.3s ease !important;\n  text-transform: none !important;\n  font-weight: 300 !important;\n}\n\n.labelField {\n  font-family: \"Inter\" !important;\n  font-size: 12px;\n}\n\n.tipoDocumentoCombo {\n  font-size: 12px !important;\n  font-family: \"Inter\" !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `styles_main__FkKqm`,
	"card": `styles_card__bKTEx`,
	"documentoTextField": `styles_documentoTextField__wft8E`,
	"usuarioTextField": `styles_usuarioTextField__hZnDg`,
	"containerEmailTextField": `styles_containerEmailTextField__VP0oV`,
	"emailTextField": `styles_emailTextField__UwQAU`,
	"containerSenhaTextField": `styles_containerSenhaTextField__NRb4D`,
	"senhaTextField": `styles_senhaTextField__iYvl7`,
	"containerConfirmarSenhaTextField": `styles_containerConfirmarSenhaTextField__JaSdl`,
	"confirmarSenhaTextField": `styles_confirmarSenhaTextField__G6bZh`,
	"botaoConfirmar": `styles_botaoConfirmar__KWArx`,
	"container": `styles_container__9M3SJ`,
	"titulo": `styles_titulo__3JW3r`,
	"botaoEnviar": `styles_botaoEnviar__VhxM2`,
	"botaoEnviar_disable": `styles_botaoEnviar_disable__l+0Hs`,
	"botaoLimpar": `styles_botaoLimpar__rSca5`,
	"labelField": `styles_labelField__1i4HA`,
	"tipoDocumentoCombo": `styles_tipoDocumentoCombo__hyCkw`
};
export default ___CSS_LOADER_EXPORT___;
